export default __webpack_public_path__ + "static/media/img3.7fa08e5c.jpg";